import { render, staticRenderFns } from "./AuthFormLink.vue?vue&type=template&id=09651926"
import script from "./AuthFormLink.vue?vue&type=script&lang=ts"
export * from "./AuthFormLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09651926')) {
      api.createRecord('09651926', component.options)
    } else {
      api.reload('09651926', component.options)
    }
    module.hot.accept("./AuthFormLink.vue?vue&type=template&id=09651926", function () {
      api.rerender('09651926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/AuthFormLink.vue"
export default component.exports